<!--

TinplateBadge
马口铁底徽章
-->

<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="徽章 > 马口铁底" name="马口铁底徽章">
        <el-row>
          <el-col :span="24" class="my-middle">
            <el-checkbox
              v-bind:key="select.id"
              v-for="select in tinplateBadge"
              v-model="select.status"
              v-bind:label="select.name"
              style="width:150px;margin:10px"
              border
            ></el-checkbox>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-collapse v-model="forcollapse" wtfname="tinplateBadgeFormActive">
              <CircularTinplateBadge v-if="tinplateBadge[0].status"/>
              <SquareTinplateBadge v-if="tinplateBadge[1].status"/>
              <HeartshapedTinplateBadge v-if="tinplateBadge[2].status"/>
              <RectangleTinplateBadge v-if="tinplateBadge[3].status"/>
            </el-collapse>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
import CircularTinplateBadge from "./TinplateBadge/CircularTinplateBadge.vue";
import SquareTinplateBadge from "./TinplateBadge/SquareTinplateBadge.vue";
import HeartshapedTinplateBadge from "./TinplateBadge/HeartshapedTinplateBadge.vue";
import RectangleTinplateBadge from "./TinplateBadge/RectangleTinplateBadge.vue";
export default {
  name: "TinplateBadge",
  methods: {},
  components: {
    CircularTinplateBadge,
    SquareTinplateBadge,
    HeartshapedTinplateBadge,
    RectangleTinplateBadge
  },
  data() {
    return {
      forcollapse: ['圆形马口铁底','方形马口铁底','心形马口铁底','长方形马口铁底'],
      tinplateBadge: [
        { id: "CircularTinplateBadge", name: "圆形", status: false },
        { id: "SquareTinplateBadge", name: "方形", status: false },
        { id: "HeartshapedTinplateBadge", name: "心形", status: false },
        { id: "RectangleTinplateBadge", name: "长方形", status: false }
      ],
      tinplateBadgeFormActive: []
    };
  }
};
</script>
<style scoped>
</style>